import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAppzgzORvaj5SYjEv4sS04fGGKv5p63Rg",
  authDomain: "test-ab6c5.firebaseapp.com",
  projectId: "test-ab6c5",
  storageBucket: "test-ab6c5.firebasestorage.app",
  messagingSenderId: "445898757603",
  appId: "1:445898757603:web:83c82f33df21c7c831bcd6",
  measurementId: "G-GCMPF2V8CH"
};

let app;
let analytics;

try {
  app = initializeApp(firebaseConfig);

  // Initialize analytics only if supported
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  }).catch(() => {
    console.log('Analytics not supported');
  });
} catch (error) {
  console.error('Error initializing Firebase:', error);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export { analytics };

export default app;